import React, { FC } from 'react';
import {
  TypeMediaCollectionAccessItemFields,
  TypeImage,
} from '@/core/generated-types';
import { TypeMediaCollectionRecord } from '@/lib/api/playbackService/types';
import { Badge, InternalLinkWrapper, LuvImage, RichText } from '@/components';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { getStatusDisplayText } from './utils';
import classNames from 'classnames';
import { TW_COURSE_ACCESS_ITEM_CLASSES } from '@/core/constants';
import { Document } from '@contentful/rich-text-types';

export interface TypeMediaCollectionAccessItemWithCourseData
  extends TypeMediaCollectionAccessItemFields {
  mediaCollection: TypeMediaCollectionRecord | null;
  isHidden?: boolean;
}

const MediaCollectionAccessItem: FC<
  TypeMediaCollectionAccessItemWithCourseData
> = ({ details, statusDisplayCopy, badge, mediaCollection, isHidden }) => {
  if (!mediaCollection || isHidden) return null;

  const {
    cta: streamingPageLink,
    textHeading,
    textBody,
    image,
  } = details?.fields || {};

  const hasStatus = badge && statusDisplayCopy;
  const statusDisplayText = hasStatus
    ? getStatusDisplayText(mediaCollection.status, statusDisplayCopy)
    : '';

  return (
    <InternalLinkWrapper
      link={streamingPageLink}
      classes={classNames(
        'container relative mx-auto h-full w-full rounded-b bg-white drop-shadow',
        TW_COURSE_ACCESS_ITEM_CLASSES.container,
      )}
    >
      {hasStatus && (
        <div className="absolute left-0 top-0 ml-6 mt-5 font-bold">
          {statusDisplayText && (
            <Badge {...{ ...badge.fields, text: statusDisplayText }} />
          )}
        </div>
      )}

      <LuvImage
        height={240}
        width={360}
        alt=""
        className={classNames(
          'w-full rounded-t',
          TW_COURSE_ACCESS_ITEM_CLASSES.image,
        )}
        imageData={image as TypeImage}
      />
      <div className="p-6 text-left">
        <Heading
          text={textHeading}
          tag={HeadingTag.H3}
          size={HeadingSize.H3}
          align="left"
        />
        {textBody && <RichText content={textBody as Document} />}
      </div>
    </InternalLinkWrapper>
  );
};

export default MediaCollectionAccessItem;
